<template>
  <div class="toolbox-menu-component" tabindex="0" aria-label="工具箱">
    <div class="menu-section">
      <ul class="size-list" role="radiogroup" aria-label="字号大小">
        <li
          v-for="tool in tools"
          :key="tool.id"
          @click="handleToolSelect(tool)"
          role="radio"
          tabindex="0"
          @keydown.enter.space="handleToolSelect(tool)"
        >
          <img :src="tool.img" alt="" />
          <span>{{ tool.label }}</span>
        </li>
        <li style="height: 0"></li>
        <li style="height: 0"></li>
      </ul>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations } from "vuex";
export default {
  name: "TextMenu",
  data() {
    return {
      tools: [
        {
          id: "timeout",
          img: require("../../assets/images/timeout.png"),
          label: "定时器",
        },
        {
          id: "interval",
          img: require("../../assets/images/interval.png"),
          label: "计时器",
        },
        {
          id: "answerer",
          img: require("../../assets/images/answerer.png"),
          label: "答题器",
        },
      ],
    };
  },
  mounted() {},
  methods: {
    ...mapMutations("live", ["setShowToolbox"]),
    handleToolSelect(tool) {
      if (this.isPc) {
        // pc 端
        this.setShowToolbox({
          [tool.id]: true,
        });
      } else {
        // pad端和app
      }
    },
  },
  computed: {
    ...mapState("live", ["whiteBoardService"]),
    ...mapState("whiteBoard", ["isPc", "role"]),
  },
};
</script>

<style lang="scss" scoped>
.toolbox-menu-component {
  width: 168px;
  background: #ffffff;
  box-shadow: 0px 12px 20px 0px rgba(90, 102, 115, 0.06),
    0px 4px 12px 0px rgba(90, 102, 115, 0.04);
  border-radius: 10px 10px 10px 10px;
  border: 1px solid #e5e6eb;
  padding: 8px;
  .size-list {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    align-items: center;
    justify-content: space-between;

    li {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      width: 48px;
      height: 67px;
      border-radius: 8px;
      cursor: pointer;
      &:hover {
        background: #e5e6eb;
      }
      img {
        width: 40px;
        height: 40px;
      }
      span {
        height: 17px;
        font-family: PingFang SC, PingFang SC;
        font-weight: 500;
        font-size: 12px;
        color: #1d2129;
        text-align: center;
        font-style: normal;
        text-transform: none;
      }
    }
  }
}
</style>
